import { Component } from '@angular/core';

@Component({
	selector: 'app-resident-customer',
	templateUrl: './resident-customer.component.html',
	styleUrls: ['./resident-customer.component.css'],
})
export class ResidentCustomerComponent {
	constructor() {}
}
